import { useEffect } from "react";
import { logUser } from "../api";

export function useUser() {
    useEffect(() => {
        const tg = window.Telegram?.WebApp;

        if (tg) {
            const user = tg.initDataUnsafe.user;

            const startParam =
                tg.initDataUnsafe.start_param ||
                tg.initDataUnsafe.startapp ||
                tg.initDataUnsafe.tgWebAppStartParam ||
                null;

            logUser({
                ...user,
                start_param: startParam
            });
        }
    }, []);
}
